import type CreativeSDK from '@cesdk/cesdk-js';
import { mmToPoints } from '@theprintbar/shared';
import { getPageScaleFactor } from './page';

interface AddTextOptions {
	text: string;
	editor: CreativeSDK;
	page: number;
	height: number;
	top?: number;
	meta?: Record<string, string>;
	placeholderId?: string;
}

export function addText({ text, editor, page, height, top, placeholderId, meta }: AddTextOptions) {
	const scaleFactor = getPageScaleFactor(editor.engine, page);
	const { block } = editor.engine;
	const pageWidth = block.getWidth(page);
	const textBlock = block.create('text');
	block.appendChild(page, textBlock);
	//Span the block across the full page and let text/horizontalAlignment do the visual
	//centring. Auto width would collapse to the text width, but getFrameWidth right after
	//replaceText hasn't been through a layout pass yet — reading it gives stale/zero and
	//the block ends up left-of-centre. Full page width + Center alignment sidesteps that.
	block.setWidth(textBlock, pageWidth);
	block.setHeightMode(textBlock, 'Auto');

	block.setTextFontSize(textBlock, mmToPoints(height));
	block.setEnum(textBlock, 'text/horizontalAlignment', 'Center');

	if (placeholderId) {
		block.replaceText(textBlock, `{{${placeholderId}}}`);
		block.setPlaceholderEnabled(textBlock, true);
		block.setPlaceholderBehaviorEnabled(textBlock, true);
		editor.engine.variable.setString(placeholderId, text);
	} else {
		block.replaceText(textBlock, text);
	}

	block.setPositionX(textBlock, 0);
	block.setPositionY(textBlock, scaleFactor * (top ?? 0));

	Object.entries(meta ?? {}).forEach(([key, value]) => {
		block.setMetadata(textBlock, key, value);
	});
	return textBlock;
}
